import { Drawer as AntdDrawer } from "@empglabs/backoffice-ui-kit"

export default function Drawer(props) {
  return <AntdDrawer {...props} />
}
